import { GenIcon } from '../helpers/IconBase.es.js';

const EndShiftOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 25 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.2903 13.0364C14.2653 13.0364 16.4918 9.95581 16.4918 7.20151C16.4918 5.80996 15.9543 4.50478 14.9659 3.5259C13.9774 2.53742 12.6722 2 11.2903 2C9.90831 2 8.59353 2.53742 7.61465 3.5259C6.63577 4.51438 6.08875 5.80996 6.08875 7.20151C6.08875 9.95581 8.31522 13.0364 11.2903 13.0364ZM8.63192 4.54317C9.34209 3.833 10.2826 3.43953 11.2903 3.43953C12.2979 3.43953 13.2384 3.833 13.9486 4.54317C14.6588 5.25334 15.0522 6.19383 15.0522 7.20151C15.0522 9.23604 13.4112 11.5969 11.2903 11.5969C9.16935 11.5969 7.52828 9.23604 7.52828 7.20151C7.52828 6.19383 7.92175 5.25334 8.63192 4.54317Z",
          fill: "#434657"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M15.129 20.5509H3.68953V17.9309C3.68953 17.7006 3.75671 17.4703 3.88147 17.2783C4.00623 17.0864 4.18857 16.9329 4.38051 16.8465C6.57819 15.954 8.90063 15.5221 11.319 15.5893C12.8449 15.5893 14.4284 15.7428 15.9447 16.0979C16.3382 16.1939 16.7221 15.9444 16.8085 15.5605C16.8948 15.1766 16.6549 14.7832 16.271 14.6968C14.6492 14.3225 12.9697 14.1498 11.319 14.1498C8.75668 14.0826 6.2327 14.5336 3.82389 15.5221C3.35364 15.7332 2.96017 16.0691 2.68186 16.501C2.39395 16.9329 2.25 17.4223 2.25 17.9405V21.2802C2.25 21.6737 2.57629 22 2.96977 22H15.129C15.5225 22 15.8488 21.6737 15.8488 21.2802C15.8488 20.8868 15.5225 20.5509 15.129 20.5509Z",
          fill: "#434657"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M18.1424 17.9979H22.1635C22.557 17.9979 22.8833 18.3242 22.8833 18.7177C22.8833 19.1112 22.557 19.4375 22.1635 19.4375H18.1424L19.4764 20.7714C19.7547 21.0497 19.7547 21.5104 19.4764 21.7887C19.3324 21.9327 19.1501 21.9998 18.9678 21.9998C18.7854 21.9998 18.6031 21.9327 18.4591 21.7887L15.8968 19.2263C15.8296 19.1592 15.7816 19.0824 15.7432 18.996C15.7048 18.9096 15.6856 18.8137 15.6856 18.7177C15.6856 18.6217 15.7048 18.5258 15.7432 18.4394C15.7816 18.353 15.8296 18.2762 15.8968 18.2091L18.4591 15.6467C18.7374 15.3684 19.1981 15.3684 19.4764 15.6467C19.7547 15.925 19.7547 16.3857 19.4764 16.664L18.1424 17.9979Z",
          fill: "#434657"
        }
      }
    ]
  })(props);
};

export { EndShiftOutlined };
